// eslint-disable-next-line
const style = (theme, scale = 1) => {
  return {
    loadingSpace: {
      minHeight: "560px",
    },
    boxRoot: {
      width: "100%",
      maxWidth: "880px",
      margin: "0 auto",
      paddingBottom: { xs: "8px", md: "20px" },
    },
    root: {
      width: "100%",
      maxWidth: "470px",
      margin: "0 auto",
      display: "grid",
      gridTemplateColumns: "minmax(0, 1fr)",
      gap: { xs: "16px", md: "20px" },
      alignItems: "start",
      textAlign: "left",
      "@media (min-width: 960px)": {
        maxWidth: "none",
        gridTemplateColumns: "470px minmax(0, 1fr)",
        alignItems: "stretch",
      },
    },
    card: {
      width: "100%",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      borderRadius: { xs: "20px", sm: "24px" },
      color: "var(--tezex-text)",
      background: "var(--tezex-panel)",
      border: "1px solid var(--tezex-line)",
      boxShadow: "var(--tezex-shadow)",
      "@media (min-width: 960px)": { height: "100%" },
    },
    cardHeader: {
      minHeight: "82px",
      padding: { xs: "17px", sm: "19px 21px" },
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "16px",
      borderBottom: "1px solid var(--tezex-line-soft)",
      "@media (max-width: 520px)": {
        minHeight: "auto",
        alignItems: "stretch",
        flexDirection: "column",
        justifyContent: "flex-start",
        padding: "16px 18px",
      },
    },
    headerTitleGroup: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    eyebrow: {
      color: "var(--tezex-muted)",
      fontSize: "10px",
      fontWeight: 700,
      letterSpacing: "0.18em",
      lineHeight: 1.2,
    },
    headerTitle: {
      color: "var(--tezex-text)",
      fontFamily: '"Inter", sans-serif',
      fontSize: { xs: "17px", sm: "19px" },
      fontWeight: 600,
      letterSpacing: "-0.02em",
      lineHeight: 1.2,
    },
    cardContent: {
      padding: { xs: "16px", sm: "20px" },
      "&.MuiCardContent-root:last-child": {
        paddingBottom: { xs: "16px", sm: "20px" },
      },
      "@media (min-width: 960px)": { flex: 1 },
    },
    amountField: {
      width: "100%",
      minHeight: { xs: "108px", sm: "116px" },
    },
    amountFieldShake: {
      animation: "tezexAmountFieldShake 320ms ease-out",
      "@keyframes tezexAmountFieldShake": {
        "0%, 100%": { transform: "translateX(0)" },
        "20%": { transform: "translateX(-4px)" },
        "40%": { transform: "translateX(4px)" },
        "60%": { transform: "translateX(-3px)" },
        "80%": { transform: "translateX(3px)" },
      },
      "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
      },
    },
    swapToggle: {
      position: "relative",
      zIndex: 3,
      width: "44px",
      height: "44px",
      margin: "0 auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    quoteLine: {
      marginTop: "14px",
      padding: "0 4px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "12px",
    },
    quoteText: {
      minWidth: 0,
      color: "var(--tezex-muted)",
      fontFamily: '"Red Hat Mono", monospace',
      fontSize: "11px",
      lineHeight: 1.5,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    quoteStatus: {
      flexShrink: 0,
      color: "var(--tezex-text-secondary)",
      fontSize: "11px",
      fontWeight: 600,
    },
    cardActions: {
      padding: { xs: "0 16px 16px", sm: "0 20px 20px" },
      display: "block",
    },
    slippageRow: {
      padding: { xs: "15px 16px", sm: "16px 20px" },
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "14px",
      borderTop: "1px solid var(--tezex-line-soft)",
      background: "var(--tezex-panel-subtle)",
      "@media (max-width: 359px)": {
        alignItems: "stretch",
        flexDirection: "column",
        "& > :last-child": { alignSelf: "flex-end" },
      },
    },
    slippageLabel: {
      color: "var(--tezex-text-secondary)",
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: 1.35,
    },
    slippageHelp: {
      color: "var(--tezex-faint)",
      fontSize: "10px",
      lineHeight: 1.45,
      marginTop: "2px",
      display: { xs: "none", sm: "block" },
    },
    contextColumn: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      "@media (min-width: 960px)": { height: "100%" },
    },
    detailsPanel: {
      overflow: "hidden",
      borderRadius: { xs: "20px", sm: "24px" },
      background: "var(--tezex-panel)",
      border: "1px solid var(--tezex-line)",
      "@media (min-width: 960px)": { order: 1 },
    },
    panelHeader: {
      minHeight: "82px",
      padding: { xs: "17px", sm: "19px 21px" },
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "16px",
      borderBottom: "1px solid var(--tezex-line-soft)",
    },
    liveBadge: {
      display: "flex",
      alignItems: "center",
      gap: "7px",
      padding: "7px 10px",
      color: "var(--tezex-text-secondary)",
      background: "var(--tezex-panel-subtle)",
      border: "1px solid var(--tezex-line)",
      borderRadius: "999px",
      fontSize: "10px",
      fontWeight: 700,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
    },
    liveDot: {
      width: "6px",
      height: "6px",
      borderRadius: "50%",
      background: "var(--tezex-network-live)",
    },
    detailList: {
      padding: { xs: "8px 18px", sm: "9px 22px" },
    },
    detailRow: {
      minHeight: "47px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "18px",
      borderBottom: "1px solid var(--tezex-line-soft)",
      "&:last-of-type": { borderBottom: "none" },
    },
    detailLabel: {
      color: "var(--tezex-muted)",
      fontSize: "12px",
      fontWeight: 500,
    },
    detailValue: {
      color: "var(--tezex-text-secondary)",
      fontSize: "12px",
      fontWeight: 600,
      textAlign: "right",
    },
    detailValueMono: {
      color: "var(--tezex-text-secondary)",
      fontFamily: '"Red Hat Mono", monospace',
      fontSize: "11px",
      fontWeight: 500,
      textAlign: "right",
    },
    contractLink: {
      color: "var(--tezex-text-secondary)",
      fontFamily: '"Red Hat Mono", monospace',
      fontSize: "11px",
      fontWeight: 500,
      textDecorationColor: "var(--tezex-faint)",
      textUnderlineOffset: "3px",
      "&:hover": {
        color: "var(--tezex-text)",
        textDecorationColor: "var(--tezex-text)",
      },
    },
    trustNote: {
      padding: { xs: "16px 18px", sm: "17px 22px" },
      color: "var(--tezex-muted)",
      background: "var(--tezex-panel-subtle)",
      borderTop: "1px solid var(--tezex-line-soft)",
      fontSize: "11px",
      lineHeight: 1.55,
    },
    statusPanel: {
      padding: { xs: "18px", sm: "20px 22px" },
      borderRadius: { xs: "20px", sm: "24px" },
      background: "var(--tezex-panel)",
      border: "1px solid var(--tezex-line)",
      "@media (min-width: 960px)": { order: 2, marginTop: "auto" },
    },
    statusHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "16px",
    },
    statusText: {
      color: "var(--tezex-text-secondary)",
      fontSize: "11px",
      fontWeight: 600,
    },
    progressRail: {
      position: "relative",
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      marginTop: "20px",
    },
    progressTrack: {
      position: "absolute",
      zIndex: 0,
      top: "6.5px",
      left: "8.3333%",
      right: "8.3333%",
      height: "2px",
      background: "var(--tezex-line-strong)",
      transform: "translateY(-50%)",
    },
    progressTrackFill: {
      position: "absolute",
      zIndex: 1,
      top: "6.5px",
      left: "8.3333%",
      height: "2px",
      background: "var(--tezex-action)",
      transform: "translateY(-50%)",
      transition: "width 520ms cubic-bezier(.22,1,.36,1)",
      "@media (prefers-reduced-motion: reduce)": { transition: "none" },
    },
    progressStep: {
      position: "relative",
      zIndex: 2,
      flexShrink: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "8px",
    },
    statusDot: {
      width: "13px",
      height: "13px",
      borderRadius: "50%",
      background: "var(--tezex-panel)",
      border: "3px solid var(--tezex-line-strong)",
      transition: "background-color 220ms ease, border-color 220ms ease",
    },
    statusDotReached: {
      background: "var(--tezex-action)",
      borderColor: "var(--tezex-action)",
    },
    statusDotCurrent: {
      position: "relative",
      background: "var(--tezex-panel)",
      borderColor: "var(--tezex-line-strong)",
      boxShadow: "none",
      "&::after": {
        content: '""',
        position: "absolute",
        inset: "-3px",
        borderRadius: "50%",
        background:
          "conic-gradient(from 0deg, transparent 0deg 175deg, color-mix(in srgb, var(--tezex-action) 12%, transparent) 205deg, color-mix(in srgb, var(--tezex-action) 38%, transparent) 250deg, color-mix(in srgb, var(--tezex-action) 72%, transparent) 305deg, var(--tezex-action) 350deg, transparent 360deg)",
        WebkitMask:
          "radial-gradient(farthest-side, transparent calc(100% - 3px), #000 0)",
        mask: "radial-gradient(farthest-side, transparent calc(100% - 3px), #000 0)",
        pointerEvents: "none",
        animation: "tezexStatusRimSpin 900ms linear infinite",
      },
      "@keyframes tezexStatusRimSpin": {
        from: { transform: "rotate(0deg)" },
        to: { transform: "rotate(360deg)" },
      },
      "@media (prefers-reduced-motion: reduce)": {
        "&::after": {
          animation: "none",
        },
      },
    },
    progressLabel: {
      color: "var(--tezex-faint)",
      fontSize: "10px",
      fontWeight: 600,
    },
    progressLabelReached: {
      color: "var(--tezex-text-secondary)",
    },
    statusFootnote: {
      marginTop: "18px",
      color: "var(--tezex-muted)",
      fontSize: "10px",
      lineHeight: 1.5,
    },
  };
};

export default style;
